import { PropsWithChildren, useState } from 'react';
import cn from 'classnames';
import { Image } from '../../../common/components/Image';

export type FooterMobileContentProps = PropsWithChildren<{
  isMobile: boolean;
  node: {
    id: string;
    label: string;
  };
}>;

function FooterMobileContent({ isMobile, node, children }: FooterMobileContentProps) {
  const [selectedNode, setSelectedNode] = useState<string | null>(null);

  const handleNodeSelection = (newSelectedNode: string) => {
    setSelectedNode(selectedNode === newSelectedNode ? null : newSelectedNode);
  };

  return (
    <nav
      className={cn('footer__nav-section', {
        'footer__nav-section--selected': selectedNode === node.id,
      })}
    >
      {isMobile ? (
        <button className="footer__nav-section-header-wrapper" onClick={() => handleNodeSelection(node.id)}>
          <h3 className="footer__nav-section-header">{node.label}</h3>
          <Image
            className="footer__nav-section-dropdown-arrow"
            src="arrow-down.svg"
            width={24}
            height={24}
            alt="arrow down"
          />
        </button>
      ) : (
        <h4 className="footer__nav-section-header">{node.label}</h4>
      )}
      {children}
    </nav>
  );
}

export default FooterMobileContent;
